import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@ohif/ui-next';
import ToggleGroup from '../ToggleGroup';
import { TrackedAssessment } from '../../services/ReportAssessmentService';

interface NoFindingsAssessmentProps {
  row: TrackedAssessment;
  onDetectionChange: (value?: boolean) => void;
}

export default function NoFindingsAssessment({
  row,
  onDetectionChange,
}: NoFindingsAssessmentProps) {
  return (
    <Table
      noScroll
      className="text-sm"
    >
      <TableHeader>
        <TableRow className="hover:bg-transparent hover:[&>th]:text-white">
          <TableHead
            scope="col"
            className="px-1 font-semibold text-white"
          >
            <span className="sr-only">Report</span>
          </TableHead>
          <TableHead
            scope="col"
            className="px-1 text-center font-semibold text-white"
          >
            Detection
          </TableHead>
        </TableRow>
      </TableHeader>

      <TableBody>
        <TableRow
          className="hover:[&>th]:text-white hover:[&>td]:text-white"
        >
          <TableHead
            scope="row"
            className="h-auto px-1 py-1 font-medium text-white"
          >
            No Findings
          </TableHead>

          <TableCell className="px-1 py-1">
            <ToggleGroup
              value={row.isDetectionCorrect}
              onChange={onDetectionChange}
              disabled={row.isSubmitted}
              label="Detection correct for the no-findings verdict"
            />
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
}
